<div class="component-main-container">
  <!-- Toast da tela (lista vazia): local, com MessageService próprio do componente -->
  <p-toast position="bottom-right" />

  <!-- Header do componente -->
  <div class="header">
    <app-page-header parentTitle="{{'service-order.sevice-order-label' | translate}}">
    </app-page-header>
  </div>

  <!--
    Barra única (proposta A): da esquerda para a direita em ordem de importância — criar (único
    verde-cheio), busca com escopo, status como grupo de botões, "Mais filtros" para o que é
    raro (prioridade, técnico), e no canto total + downloads. Sem botão Filtrar: busca aplica
    no Enter, o resto aplica ao mudar. Filtro escondido nunca fica invisível: badge + chips.
  -->
  <div class="os-command" [formGroup]="filterForm">
    <div class="os-bar">
      <p-button [label]="'service-order.button-new' | translate" icon="pi pi-plus" styleClass="btn-actions"
        (onClick)="openCreateDialog()" />

      <!-- ID da OS e Instalação são igualdade exata no backend: um campo, um escopo por vez -->
      <div class="os-scope" role="search">
        <select class="os-scope-select" formControlName="searchScope" (change)="onScopeChange()"
          [attr.aria-label]="'service-order.search-scope-label' | translate">
          <option value="reference">{{ 'service-order.reference-label' | translate }}</option>
          <option value="installationReference" [title]="'service-order.installation-tooltip' | translate">
            {{ 'service-order.installation-label' | translate }}
          </option>
          <option value="serialNumber">{{ 'service-order.search-scope-serial' | translate }}</option>
        </select>
        <i class="pi pi-search os-scope-icon"></i>
        <input pInputText class="os-scope-input" id="os-search" formControlName="search" autocomplete="off"
          [placeholder]="'service-order.search-placeholder' | translate" (keydown.enter)="applySearch()" />
        @if (filterForm.value.search) {
        <button type="button" class="os-scope-clear" (click)="clearSearch()"
          [attr.aria-label]="'service-order.button-clear-all' | translate">
          <i class="pi pi-times"></i>
        </button>
        }
      </div>

      <!-- Status é o filtro usado o dia inteiro: um clique, aplica na hora -->
      <div class="os-seg" role="group" [attr.aria-label]="'service-order.status-label' | translate">
        <button type="button" class="os-seg-btn" [class.os-seg-btn--on]="!filterForm.value.status"
          (click)="setStatus('')">{{ 'service-order.filter-all-option' | translate }}</button>
        @for (option of statusOptions; track option.value) {
        <button type="button" class="os-seg-btn" [class.os-seg-btn--on]="filterForm.value.status === option.value"
          (click)="setStatus(option.value)">
          <span class="os-seg-dot" [ngClass]="'os-seg-dot--' + statusMeta(option.value).severity"></span>
          {{ option.label }}
        </button>
        }
      </div>

      <!-- Prioridade e técnico são raros: ficam a um clique, com badge do que está aplicado -->
      <button type="button" class="os-more" [class.os-more--active]="hiddenFilterCount > 0"
        (click)="moreFilters.toggle($event)" [attr.aria-expanded]="moreFiltersOpen"
        [attr.aria-label]="'service-order.button-more-filters' | translate">
        <i class="pi pi-sliders-h"></i>
        {{ 'service-order.button-more-filters' | translate }}
        @if (hiddenFilterCount > 0) {
        <span class="os-more-badge">{{ hiddenFilterCount }}</span>
        }
      </button>

      <p-popover #moreFilters styleClass="os-more-popover" (onShow)="moreFiltersOpen = true"
        (onHide)="moreFiltersOpen = false">
        <div class="os-more-body" [formGroup]="filterForm">
          <div class="os-more-field">
            <label class="os-label" for="os-filter-priority">{{ 'service-order.priority-label' | translate }}</label>
            <select id="os-filter-priority" class="os-select" formControlName="priority"
              (change)="applyHiddenFilters()">
              <option value="">{{ 'service-order.filter-all-option' | translate }}</option>
              @for (option of priorityOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>
          <div class="os-more-field">
            <label class="os-label" for="os-filter-assignee">{{ 'service-order.assigned-to' | translate }}</label>
            <!-- Sem appendTo: o painel de sugestões precisa ficar dentro do popover, senão o clique
                 na sugestão conta como clique fora e fecha o popover antes de selecionar -->
            <p-autoComplete inputId="os-filter-assignee" class="w-full" formControlName="selectedUser"
              [suggestions]="filterUserList" (completeMethod)="searchUser($event)" optionLabel="displayName"
              [forceSelection]="true" [delay]="350" (onSelect)="applyHiddenFilters()"
              (onClear)="applyHiddenFilters()" [emptyMessage]="'service-order.no-results-found' | translate">
            <ng-template let-user #item>
              <span class="os-user-option">
                <span class="os-user-option-name">{{ user.displayName }}</span>
                @if (user.username && user.username !== user.displayName) {
                <span class="os-user-option-login">{{ user.username }}</span>
                }
              </span>
            </ng-template>
          </p-autoComplete>
          </div>
          <div class="os-more-foot">
            <span>{{ 'service-order.applies-on-select' | translate }}</span>
            <button type="button" class="os-link" (click)="clearHiddenFilters()"
              [disabled]="hiddenFilterCount === 0">{{ 'service-order.button-clear-these' | translate }}</button>
          </div>
        </div>
      </p-popover>

      <!-- Utilitários, quietos: total e exportação do filtro inteiro -->
      <div class="os-util">
        @if (filterLoading) {
        <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s"
          [style]="{ width: '20px', height: '20px' }" />
        }
        @if (ELEMENT_DATA.length) {
        <!-- O contador é o gatilho do tamanho da página: sem controle extra na barra -->
        <button type="button" class="os-total os-total--btn" (click)="pageSizeMenu.toggle($event)"
          [attr.aria-expanded]="pageSizeMenuOpen" [attr.aria-label]="'service-order.items-per-page' | translate">
          @if (hasNextPage) {
          {{ 'service-order.items-range' | translate: { from: pageIndex * pageSize + 1, to: pageIndex * pageSize + ELEMENT_DATA.length } }}
          } @else {
          {{ 'service-order.total-items' | translate }} <b>{{ length }}</b>
          }
          <i class="pi pi-chevron-down os-total-caret" aria-hidden="true"></i>
        </button>
        <p-popover #pageSizeMenu styleClass="os-pagesize-popover" (onShow)="pageSizeMenuOpen = true"
          (onHide)="pageSizeMenuOpen = false">
          <div class="os-pagesize-label">{{ 'service-order.items-per-page' | translate }}</div>
          @for (size of pageSizeOptions; track size) {
          <button type="button" class="os-pagesize-option" [class.os-pagesize-option--active]="size === pageSize"
            (click)="changePageSize(size); pageSizeMenu.hide()">{{ size }}</button>
          }
        </p-popover>
        <span class="os-vsep"></span>
        <span class="os-downloads">
          @if (fileLoading) {
          <span class="os-downloads-label">{{ 'service-order.generating-file' | translate }}</span>
          <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s"
            [style]="{ width: '18px', height: '18px' }" />
          } @else {
          <span class="os-downloads-label">{{ 'service-order.downloads-label' | translate }}</span>
          <button type="button" class="os-download" (click)="generateFileData(null, 'CSV')" pTooltip="CSV"
            tooltipPosition="bottom" aria-label="CSV">
            <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"/></svg>
          </button>
          <button type="button" class="os-download" (click)="generateFileData(null, 'PDF')" pTooltip="PDF"
            tooltipPosition="bottom" aria-label="PDF">
            <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/></svg>
          </button>
          }
        </span>
        }
      </div>
    </div>

    <!-- Linha de chips só enquanto houver filtro escondido ativo -->
    @if (activeHiddenFilters.length) {
    <div class="os-chips">
      <span class="os-chips-label">{{ 'service-order.filter-active-label' | translate }}:</span>
      @for (filter of activeHiddenFilters; track filter.control) {
      <span class="os-chip">
        {{ filter.labelKey | translate }}: <b>{{ filter.valueKey ? (filter.valueKey | translate) : filter.text }}</b>
        <button type="button" class="os-chip-remove" (click)="removeHiddenFilter(filter.control)"
          [attr.aria-label]="'service-order.button-clear-all' | translate">
          <i class="pi pi-times"></i>
        </button>
      </span>
      }
      <button type="button" class="os-link" (click)="clearAllFilters()">
        {{ 'service-order.button-clear-all' | translate }}
      </button>
    </div>
    }
  </div>

  @if (ELEMENT_DATA.length) {
  <div class="table-container mt-2">
    <!--
      Scroll só dentro da tabela: cabeçalho e paginador ficam fixos, o corpo rola (scrollable + flex).
      40rem cabe em tablet (768px) com a sidebar; abaixo disso a barra horizontal aparece na tabela,
      nunca na página.
    -->
    <p-table [value]="ELEMENT_DATA" [tableStyle]="{ 'min-width': '40rem' }" dataKey="id" [paginator]="true"
      [scrollable]="true" scrollHeight="flex"
      (onPage)="pageChanged($event)" [rows]="pageSize" [first]="pageIndex * pageSize" [totalRecords]="length"
      [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true" [rowHover]="true"
      [sortField]="sortField" [sortOrder]="sortOrder" [customSort]="true" (onSort)="sortChanged($event)">
      <ng-template pTemplate="header">
        <tr>
          <!-- Ordenação no servidor (sortChanged): a paginação é por offset, ordenar só a página não serve -->
          <th scope="col" pSortableColumn="reference">
            {{ 'service-order.reference-label' | translate }}
            <p-sortIcon field="reference" />
          </th>
          <th scope="col" [pTooltip]="'service-order.installation-tooltip' | translate" tooltipPosition="top">
            {{ 'service-order.installation-label' | translate }}
          </th>
          <th scope="col" class="col-status">{{ 'service-order.status-label' | translate }}</th>
          <th scope="col" class="col-priority">{{ 'service-order.priority-label' | translate }}</th>
          <th scope="col" class="col-assignee">{{ 'service-order.assigned-to' | translate }}</th>
          <th scope="col" class="col-problems">{{ 'service-order.problems-label' | translate }}</th>
          <th scope="col" class="col-notes">{{ 'service-order.notes-label' | translate }}</th>
          <th scope="col" class="col-created-at" pSortableColumn="createdAt">
            {{ 'service-order.created-at-label' | translate }}
            <p-sortIcon field="createdAt" />
          </th>
          <th scope="col" class="col-actions">{{ 'service-order.actions-label' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-element>
        <!-- A linha inteira abre a Ficha da OS em leitura; as ações têm stopPropagation -->
        <tr class="os-row" (click)="openDialog(element, false)">
          <td>
            <!-- Hover no ID abre o cartão de resumo da OS -->
            <button type="button" class="os-row-link" (click)="$event.stopPropagation(); openDialog(element, false)"
              (mouseenter)="schedulePeek($event, element)" (mouseleave)="cancelPeek()"
              [attr.aria-label]="('service-order.action-view-tooltip' | translate) + ' ' + element.reference">
              {{ element.reference }}
            </button>
          </td>
          <td>{{ element.installation?.reference }}</td>
          <td class="col-status">
            <!-- Em tela estreita a badge vira só ícone (CSS) e o rótulo passa para o tooltip -->
            <p-tag [severity]="statusMeta(element.status).severity" [icon]="statusMeta(element.status).icon"
              [value]="statusMeta(element.status).labelKey | translate"
              [styleClass]="statusMeta(element.status).styleClass"
              [pTooltip]="statusMeta(element.status).labelKey | translate" tooltipPosition="top"
              [tooltipDisabled]="!compactStatus" />
          </td>
          <td class="col-priority">
            <span class="prio-pill" [ngClass]="priorityMeta(element.priority).cssClass">
              <i [class]="priorityMeta(element.priority).icon"></i>
              {{ priorityMeta(element.priority).labelKey | translate }}
            </span>
          </td>
          <td class="col-assignee">
            @if (element.assignee?.displayName) {
            {{ element.assignee.displayName }}
            } @else {
            <span class="detail-empty">—</span>
            }
          </td>
          <!-- Texto truncado na célula, completo no tooltip -->
          <td class="col-problems os-text-cell" [pTooltip]="element.problems" tooltipPosition="top"
            tooltipStyleClass="tooltip-long-text" [tooltipDisabled]="!element.problems">
            @if (element.problems) {
            <span class="os-text-truncate">{{ truncate(element.problems, 60) }}</span>
            } @else {
            <span class="detail-empty">—</span>
            }
          </td>
          <td class="col-notes os-text-cell" [pTooltip]="element.notes" tooltipPosition="top"
            tooltipStyleClass="tooltip-long-text" [tooltipDisabled]="!element.notes">
            @if (element.notes) {
            <span class="os-text-truncate os-text-truncate--short">{{ truncate(element.notes, 40) }}</span>
            } @else {
            <span class="detail-empty">—</span>
            }
          </td>
          <!-- Data curta na célula, completa (com fuso) no title -->
          <td class="col-created-at" [title]="element.createdAt">{{ shortDate(element.createdAt) }}</td>
          <!-- Altura fixa na célula: linha sem ação (OS fechada) tinha altura diferente das outras -->
          <td class="col-actions os-actions" (click)="$event.stopPropagation()">
            <div class="os-actions-inner">
              @if (isClosedStatus(element.status)) {
              <span class="detail-empty" aria-hidden="true">—</span>
              } @else {
              <button type="button" class="os-action" (click)="openDialog(element, true)"
                [pTooltip]="'service-order.action-edit-tooltip' | translate" tooltipPosition="top"
                [attr.aria-label]="'service-order.action-edit-tooltip' | translate">
                <i class="pi pi-pen-to-square"></i>
              </button>

              @if (element.status === 'OPEN') {
              <button type="button" class="os-action os-action--go" (click)="startServiceOrder(element.id)"
                [pTooltip]="'service-order.button-start' | translate" tooltipPosition="top"
                [attr.aria-label]="'service-order.button-start' | translate">
                <i class="pi pi-play"></i>
              </button>
              }

              @if (element.status === 'IN_PROGRESS') {
              <button type="button" class="os-action os-action--go" (click)="closeServiceOrder(element.id)"
                [pTooltip]="'service-order.button-close' | translate" tooltipPosition="top"
                [attr.aria-label]="'service-order.button-close' | translate">
                <i class="pi pi-flag-fill"></i>
              </button>
              }
              }
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  } @else if (hasLoadedOnce && !filterLoading) {
  <!-- Mesmo card branco da tabela: a área de resultados não muda de forma quando vem vazia -->
  <div class="table-container mt-2">
    <div class="os-empty-state">
      <i class="pi pi-inbox"></i>
      <p>{{ 'service-order.empty-list' | translate }}</p>
    </div>
  </div>
  }

  <!--
    Cartão de resumo (proposta B): pré-visualização da ficha ao passar o mouse no ID. Um só
    popover para a tabela inteira; fecha ao sair do ID/cartão, ao clicar fora ou ao abrir a ficha.
    Só seções com texto: OS sem defeitos/observação/relatório nem abre o cartão.
  -->
  <p-popover #peek styleClass="os-peek-popover" [dismissable]="true" [focusOnShow]="false"
    (onHide)="onPeekHidden()">
    @if (peekServiceOrder; as peeked) {
    <div class="os-peek">
      <div class="os-peek-head">
        <span class="os-peek-k">{{ 'service-order.id-label' | translate }}</span>
        <span class="os-peek-v">{{ peeked.reference }}</span>
        <span class="os-peek-sep">·</span>
        <span class="os-peek-k" [title]="'service-order.installation-tooltip' | translate">{{ 'service-order.installation-label' | translate }}</span>
        <span class="os-peek-v">{{ peeked.installation.reference || '—' }}</span>
        <span class="os-peek-grow"></span>
        <p-tag [severity]="statusMeta(peeked.status).severity" [icon]="statusMeta(peeked.status).icon"
          [value]="statusMeta(peeked.status).labelKey | translate" [styleClass]="statusMeta(peeked.status).styleClass" />
        <span class="prio-pill" [ngClass]="priorityMeta(peeked.priority).cssClass">
          <i [class]="priorityMeta(peeked.priority).icon"></i>
          {{ priorityMeta(peeked.priority).labelKey | translate }}
        </span>
      </div>

      <div class="os-peek-body">
        @for (section of peekSections; track section.key) {
        <div class="os-peek-sec" [ngClass]="'os-peek-sec--' + section.key">
          <span class="os-peek-sec-title">{{ section.labelKey | translate }}</span>
          <p class="os-peek-sec-text" [class.os-peek-sec-text--empty]="!section.value">
            {{ section.value || ('— ' + (section.emptyKey | translate)) }}
          </p>
        </div>
        }
      </div>

      <div class="os-peek-foot">
        <span>{{ 'service-order.assigned-to' | translate }} <b>{{ peeked.assignee?.displayName || '—' }}</b></span>
        <span>{{ 'service-order.timeline-created' | translate }} <b>{{ shortDate(peeked.createdAt) || '—' }}</b></span>
        @if (peeked.closedAt && isClosedStatus(peeked.status)) {
        <span>{{ 'service-order.timeline-closed' | translate }} <b>{{ shortDate(peeked.closedAt) }}</b></span>
        } @else if (peeked.startedAt && peeked.status === 'IN_PROGRESS') {
        <span>{{ 'service-order.timeline-started' | translate }} <b>{{ shortDate(peeked.startedAt) }}</b></span>
        }
        <span class="os-peek-hint">{{ 'service-order.peek-hint' | translate }}</span>
      </div>
    </div>
    }
  </p-popover>

  @if (createDialogOpen) {
  <app-service-order-create-dialog (closed)="closeCreateDialog()" (created)="onCreated($event)">
  </app-service-order-create-dialog>
  }

  @if (selectedServiceOrder) {
  <app-service-order-dialog [serviceOrder]="selectedServiceOrder" [startInEditMode]="openInEditMode"
    [hasPrevious]="hasPreviousServiceOrder" [hasNext]="hasNextServiceOrder" [position]="selectedPosition"
    [total]="ELEMENT_DATA.length"
    (previous)="showPreviousServiceOrder()" (next)="showNextServiceOrder()" (closed)="closeDialog()"
    (saved)="onDetailSaved()" (start)="startServiceOrder($event)" (close)="closeServiceOrder($event)">
  </app-service-order-dialog>
  }

  @if (finishTarget) {
  <app-service-order-finish-dialog [serviceOrder]="finishTarget" [loading]="finishLoading"
    (confirmed)="confirmFinish($event)" (cancelled)="cancelFinish()">
  </app-service-order-finish-dialog>
  }
</div>
